<template>
    <div class="p-5">
        <h2 class="mb-4 text-center">Ways to help and support us</h2>
        <div class="col-md-6 offset-3">

            <p class="text-muted mb-5 text-center">
                Energy Efficiency is a growing concern in today’s market and NLCAA is doing what we can to help create
                awareness to the changing laws, codes, and standards of Title 24. As we present more classes to reach a bigger audience,
                upgrade our software to make it as user-friendly as possible, and work with the state to update regulations during code cycles,
                we ask for your support in this growing industry. By clicking below you can donate to the cause.
            </p>

            <div class="mt-3" v-if="!isSuccess">

                <form action="#" method="post">

                    <div class="form-group">
                        <label for="slc_amount">Amount</label>
                        <select id="slc_amount" v-model="form.amount" class="form-control" @change="updatePaymentIntent()">
                            <option v-for="amount, index in amounts" :value="index" v-text="amount"></option>
                        </select>
                    </div>

                    <field-input v-model="form.name" name="first_name" placeholder="Name"></field-input>
                    <field-input type="email" v-model="form.stripeEmail" name="email" placeholder="Email Address"></field-input>
                    <field-text v-model="form.notes" name="notes" placeholder="Comments (Optional) "></field-text>

                    <payment-form :url="`/donations`" class="my-4"
                        @on-accepted="checkout"
                        @on-declined="onDeclined">
                    </payment-form>

                    <!-- <submit-button :form="form" class="btn btn-primary" icon="fa-paper-plane" @click="submitPayment()">Donate</submit-button> -->

                    <submit-button  icon="fa-paper-plane" :form="form" @click="submit()" processing-text="Processing...">Submit</submit-button>
                </form>



            </div>


            <div v-else>
                <h4 class="text-success" style="width: 500px; margin: 0 auto">
                    Thank You for support NLCAA!<br>We will add your name and email to our sponsors list.
                </h4>
            </div>
        </div>


    </div>
</template>
<script>
export default{

    props:{
        amounts: {
            type: Object,
            required: true,
        },

        user:{
            type: Object,
            required:false,
        }

    },

    data(){
        return{
            form: new Form({
                amount: 5000,
                name:'',
                notes:'',
                stripeEmail: '',
                stripeToken: '',
            }),
            isSuccess: false,
        }
    },
    mounted(){
       if (this.user) {
        this.form.name = this.user.name;
        this.form.stripeEmail = this.user.email;
       }
    },

    created(){
        // this.stripe = StripeCheckout.configure({
        //     'key': App.config.stripeKey,
        //     'image': '/images/logo-solo.png',
        //     'color': 'white',
        //     'panelLabel': 'Donate: ',
        //     'locale' : 'en-EN',
        //     token: function(token) {
        //         this.form.stripeToken = token.id;
        //         this.form.stripeEmail = token.email;
        //         this.submitPayment();
        //     }.bind(this)
        // })
    },
    methods: {
        submit() {
            this.form.isSubmitted = true;
                App.bus.$emit('submit-payment-form');
            },

        updatePaymentIntent(){
            App.request(`/donations/${this.form.amount}`).then(response => {

            })
        },

        onDeclined(){
                this.form.isSubmitted = false;
        },

        checkout(stripeToken) {
            console.log("entrando a checkout");
            this.form.stripeToken = stripeToken;
            this.form.post(`/donations`).then(response => {
                // this.refreshPage();
                this.isSuccess = true;
            }).catch(errors => {
                Alert.error(errors.first());
            })
        },

        // donate(){
        //     this.stripe.open({
        //         name: 'NLCAA',
        //         description: 'Support and Donations',
        //         amount: this.form.amount
        //     })
        // },
        //

        // submitPayment() {
        //     this.form.post(`/donations/`).then(response => {
        //         this.form.amount = 5000;
        //         this.isSuccess = true;
        //     }).catch(error => {
        //     })
        // },
    },
}
</script>